/*
 * Panier — cohérence d'un groupe de personnalisation.
 *
 * Une peluche personnalisée et ses options forment un groupe (`_perso_group`,
 * posé à l'ajout par perso-cart-bridge.js). Le thème, lui, ne connaît que des
 * lignes indépendantes. Deux conséquences à corriger :
 *   1. retirer la peluche laissait ses options au panier — le client pouvait
 *      payer un pochon brodé sans peluche à broder ;
 *   2. les orphelins déjà présents dans un panier restaient facturés.
 */
(function () {
  if (window.__persoCartGroup) return;
  window.__persoCartGroup = true;

  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  function getCart() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function applyUpdates(updates) {
    return fetch(root + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update refusé');
      return r.json();
    });
  }

  function groupOf(item) {
    return (item.properties && item.properties._perso_group) || null;
  }

  function isAddon(item) {
    return !!(item.properties && item.properties._perso_option);
  }

  // 1. Retirer la peluche retire tout son groupe.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-remove-item]');
      if (!btn) return;
      var line = btn.closest('[data-perso-main]');
      if (!line) return; // ligne ordinaire : comportement natif du thème
      var group = line.getAttribute('data-perso-group');
      if (!group) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      getCart()
        .then(function (cart) {
          var updates = {};
          cart.items.forEach(function (i) {
            if (groupOf(i) === group) updates[i.key] = 0;
          });
          return applyUpdates(updates);
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function (err) {
          console.error('[perso] suppression du groupe impossible', err);
          window.location.reload(); // au pire, on retombe sur l'état réel du panier
        });
    },
    true // capture : passer avant le handler du thème
  );

  // 2. Nettoyer les options dont la peluche n'est plus au panier.
  // Pas de boucle possible : on ne recharge que si l'update a réussi, et il n'y
  // a alors plus d'orphelin à retirer au chargement suivant.
  getCart()
    .then(function (cart) {
      var mains = {};
      cart.items.forEach(function (i) {
        var g = groupOf(i);
        if (g && !isAddon(i)) mains[g] = true;
      });
      var updates = {};
      var found = false;
      cart.items.forEach(function (i) {
        var g = groupOf(i);
        if (g && isAddon(i) && !mains[g]) {
          updates[i.key] = 0;
          found = true;
        }
      });
      if (!found) return null;
      console.info('[perso] option(s) sans peluche retirée(s) du panier');
      return applyUpdates(updates).then(function () {
        window.location.reload();
      });
    })
    .catch(function (err) {
      console.error('[perso] nettoyage des orphelins impossible', err);
    });
})();
